import { baseUrl, jwtHeaders } from '../common/data';


export const monthwisesalesreport = async (branchId, year) => {
  const response = await fetch(
    `${baseUrl}/api/reports/monthwisesalesreport/${branchId ? branchId : ''}?year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const monthwiseexpensereport = async (branchId, year) => {
  const response = await fetch(
    `${baseUrl}/api/reports/monthwiseexpensereport/${branchId ? branchId : ''}?year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const topperformer = async (branchId, year, month) => {
  const response = await fetch(
    `${baseUrl}/api/reports/topperformer/${branchId ? branchId : ''}?year=${year}&month=${month}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const staffperformance = async (branchId, year) => {
  const response = await fetch(
    `${baseUrl}/api/reports/staffperformance/${branchId ? branchId : ''}?year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const topserviceproducts = async (branchId, year) => {
  const response = await fetch(
    `${baseUrl}/api/reports/topserviceproducts/${branchId ? branchId : ''}?year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const topmembershippackages = async (branchId, year) => {
  const response = await fetch(
    `${baseUrl}/api/reports/topmembershippackages/${branchId ? branchId : ''}?year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const getAvailableReportModels = async () => {
  const response = await fetch(
    `${baseUrl}/api/reports/export/available-models`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const exportReport = async (branchId, model, format, from, to, fields, billSubType) => {
  const params = new URLSearchParams({ model, format });
  if (branchId) params.append('branchId', branchId);
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  if (fields) params.append('fields', fields); // fields = "Invoice No,Client Name,..."
  if (billSubType) params.append('billSubType', billSubType);

  const response = await fetch(
    `${baseUrl}/api/reports/export?${params.toString()}`,
    { method: 'GET', headers: jwtHeaders(), redirect: 'follow' },
  );

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData?.message || 'Failed to export report');
  }

  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition');
  let filename = `${model}-report.${format === 'excel' ? 'xlsx' : 'pdf'}`;
  const match = disposition && disposition.match(/filename="(.+)"/);
  if (match) filename = match[1];

  return { blob, filename };
};

export const exportCombinedReport = async (format, branchId, from, to, reports) => {
  const response = await fetch(`${baseUrl}/api/reports/exportCombined`, {
    method: 'POST',
    headers: {
      ...jwtHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      format,
      branchId: branchId || undefined,
      from: from || undefined,
      to: to || undefined,
      reports,
    }),
    redirect: 'follow',
  });
 
  if (!response.ok) {
    // backend sends JSON on validation/server errors, so parse that
    // instead of trying to treat an error response as a file
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData?.message || 'Failed to export combined report');
  }
 
  const blob = await response.blob();
 
  const disposition = response.headers.get('Content-Disposition');
  let filename = `combined-report.${format === 'excel' ? 'xlsx' : 'pdf'}`;
  const match = disposition && disposition.match(/filename="(.+)"/);
  if (match) filename = match[1];
 
  return { blob, filename };
};